import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestService } from '../rest/rest.service';
import { QuoteDetailType, RecentQuotes, RecentQuotesResponse, SecuritySymbol } from '../../domain/public-api';
import { RecentQuotesMapperService } from './recent-quotes-mapper.service';

/**
 * Recent Quotes Rest Service
 */
@Injectable({
  providedIn: 'root'
})
export class RecentQuotesRestService {

  private static readonly GET_RECENT_QUOTES_RESOURCE_ID: string = 'customer.symbolgroup';
  private static readonly ADD_TO_RECENT_QUOTES_RESOURCE_ID: string = 'customer.addUserSymbols';
  private static readonly DELETE_FROM_RECENT_QUOTES_RESOURCE_ID: string = 'customer.deleteSymbols';

  constructor(private restService: RestService,
              private recentQuotestMapper: RecentQuotesMapperService) {}

  /**
   * Returns observable that emits recent quotes.
   *
   * @param quoteType Quote type
   * @returns Observable for getting recent quotes
   */
  getRecentQuotes(quoteType: Array<QuoteDetailType>, hasFundamentals: boolean): Observable<RecentQuotes> {
    const params = {
      pathVariables: {
        name: 'QUOTES'
      },
      params: {
        quoteType
      }
    };
    return this.restService.getResource(RecentQuotesRestService.GET_RECENT_QUOTES_RESOURCE_ID).get<RecentQuotesResponse>(params)
      .pipe(map((response: RecentQuotesResponse): RecentQuotes => this.recentQuotestMapper.mapRecentQuotes(response, hasFundamentals)));
  }

  /**
   * Adds array of symbols to recent quotes
   *
   * @param symbols Array of symbols to add
   * @returns Http response
   */
  addToRecentQuotes(symbols: Array<SecuritySymbol>): Observable<unknown> {
    const payload = {
      name: 'QUOTES',
      symbols
    };
    return this.restService.getResource(RecentQuotesRestService.ADD_TO_RECENT_QUOTES_RESOURCE_ID).post(payload);
  }

  /**
   * Deletes quote from recent quotes
   *
   * @param ids Single ID or Array of IDs of recent quotes to delete
   * @returns Http response
   */
  deleteRecentQuotesByIds(ids: number | Array<number>): Observable<void> {
    return this.restService.getResource(RecentQuotesRestService.DELETE_FROM_RECENT_QUOTES_RESOURCE_ID)
      .del(undefined, { params: { id: ids } });
  }
}

